import { deliveryWindow, formatDeliveryRange } from '@theme/sk-logic';

/**
 * Replaces the server fallback ("7-12 dni roboczych") with real dates, e.g. "14 - 21 paź".
 * Business days only. The dates are an estimate, shown as "Dostawa zwykle ...".
 */
class SkDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const min = Number(this.dataset.min);
    const max = Number(this.dataset.max);
    const target = this.querySelector('[data-sk-range]');
    if (!target || !Number.isFinite(min) || !Number.isFinite(max) || min < 1 || max < min) return;

    const { from, to } = deliveryWindow(new Date(), min, max);
    target.textContent = formatDeliveryRange(from, to, document.documentElement.lang || 'pl-PL');
  }
}

if (!customElements.get('sk-delivery-estimate')) {
  customElements.define('sk-delivery-estimate', SkDeliveryEstimate);
}
